import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'
import moment from 'moment-timezone'

import { formatTime, userDateFormat } from 'services/time_format'

export const StepTime = ({ timeString, timezone: tz, dateNotation, timeNotation }) => {
  const date = userDateFormat(moment(timeString).tz(tz), dateNotation, 'date_medium')
  const time = formatTime(moment(timeString).tz(tz), timeNotation).replace(':00', ' ')
  const timezone = moment.tz(tz).format('z')
  return (
    <BodyText size="x-small" color="muted">
      {I18n.t('publisher.meetings.timeline.time', { date, time, timezone })}
    </BodyText>
  )
}
